// src/components/MovieCard.jsx
import React from "react";
import "./MovieCard.css";

const IMG_BASE = "https://image.tmdb.org/t/p";

export default function MovieCard({
                                      movie,
                                      onOpen = () => {},
                                      imgSize = "w342", // w185 | w342 | w500
                                  }) {
    const poster = movie?.poster_path
        ? `${IMG_BASE}/${imgSize}${movie.poster_path}`
        : null;

    const rating =
        typeof movie?.vote_average === "number"
            ? movie.vote_average.toFixed(1)
            : "—";

    return (
        <article
            className="mcard"
            role="button"
            onClick={() => onOpen(movie)}
            aria-label={`Open ${movie?.title || movie?.name || "movie"}`}
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onOpen(movie)}
        >
            <div className="mcard__media">
                {poster ? (
                    <img
                        src={poster}
                        alt={movie?.title || movie?.name || "Movie poster"}
                        loading="lazy"
                    />
                ) : (
                    <div className="mcard__placeholder" aria-label="no poster">
                        <div className="mcard__placeholderIcon" aria-hidden>🎬</div>
                        <div className="mcard__placeholderTitle">{movie.title}</div>
                    </div>
                )}

                <div className="mcard__badge" aria-label={`Rating ${rating}`}>
                    <span className="mcard__star" aria-hidden>★</span>
                    <span className="mcard__rating">{rating}</span>
                </div>
            </div>
        </article>
    );
}
